import { useState } from 'react';
import { useSuperAdmin } from '@/hooks/useSuperAdmin';
import {
  Sheet,
  SheetContent,
} from '@/components/ui/sheet';
import { ControlBar } from '@/components/ui/control-bar';
import { Settings, HelpCircle, Users, Building2 } from 'lucide-react';
import { InfrastructurePanel } from './InfrastructurePanel';
import { HelpAdminPanel } from './HelpAdminPanel';
import { EnterprisePanel } from './EnterprisePanel';
import { AccountsPanel } from './AccountsPanel';

type PanelType = 'infrastructure' | 'help' | 'enterprise' | 'accounts' | null;

export function AdminBar() {
  const { isSuperAdmin, isLoading } = useSuperAdmin();
  const [activePanel, setActivePanel] = useState<PanelType>(null);

  if (isLoading || !isSuperAdmin) return null;

  const closePanel = () => setActivePanel(null);

  return (
    <>
      <ControlBar
        label="Admin"
        accentClassName="bg-gradient-to-r from-indigo-600 to-purple-600 text-white"
        items={[
          { icon: Settings, label: 'Infrastructure', onClick: () => setActivePanel('infrastructure') },
          { icon: HelpCircle, label: 'Help Center', onClick: () => setActivePanel('help') },
          { icon: Building2, label: 'Enterprise', onClick: () => setActivePanel('enterprise') },
          { icon: Users, label: 'Accounts', onClick: () => setActivePanel('accounts') },
        ]}
      />

      <Sheet open={activePanel === 'infrastructure'} onOpenChange={(open) => !open && closePanel()}>
        <SheetContent side="right" className="w-[600px] sm:max-w-[600px]">
          <InfrastructurePanel />
        </SheetContent>
      </Sheet>

      <Sheet open={activePanel === 'help'} onOpenChange={(open) => !open && closePanel()}>
        <SheetContent side="right" className="w-[600px] sm:max-w-[600px] overflow-y-auto">
          <HelpAdminPanel />
        </SheetContent>
      </Sheet>

      <Sheet open={activePanel === 'enterprise'} onOpenChange={(open) => !open && closePanel()}>
        <SheetContent side="right" className="w-[800px] sm:max-w-[800px] overflow-y-auto">
          <EnterprisePanel />
        </SheetContent>
      </Sheet>

      <Sheet open={activePanel === 'accounts'} onOpenChange={(open) => !open && closePanel()}>
        <SheetContent side="right" className="w-[800px] sm:max-w-[800px] overflow-y-auto">
          <AccountsPanel />
        </SheetContent>
      </Sheet>
    </>
  );
}
